import Layout from "@/views/Layout.vue";

const router = [
  {
    path: "/news", //新闻动态
    name: "news",
    component: () => import("@/views/news/Index.vue"),
  },
  {
    path: "/news/detail", //新闻动态详情
    name: "newsDetail",
    component: () => import("@/views/news/Detail.vue"),
  },
];
const routerItem = {
  path: "/",
  redirect: "/news",
  component: Layout,
  children: router,
};

export default routerItem;
